import { render } from "./DashboardRanking.vue?vue&type=template&id=2933735f&scoped=true"
import script from "./DashboardRanking.vue?vue&type=script&lang=js"
export * from "./DashboardRanking.vue?vue&type=script&lang=js"

import "./DashboardRanking.vue?vue&type=style&index=0&id=2933735f&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2933735f"]])

export default __exports__